import {
  DEFAULT_HERO_LAYOUT,
  heroLayoutOptions,
  heroTextToneOptions,
  resolveHeroTextPosition,
  resolveOptionId,
} from './storefrontStyleOptions'

const hasText = (value) => typeof value === 'string' && value.trim() !== ''

export const normalizeHeroValuesForEditing = (
  hero = {},
  {
    defaultButtonText = 'Shop Flowers',
    defaultFocalPointX = 50,
    defaultFocalPointY = 50,
    defaultLayout = DEFAULT_HERO_LAYOUT,
    layoutOptions = heroLayoutOptions,
  } = {}
) => {
  const { showText, showButton, preferredTextPosition, preferredTextTone, ...editableHero } = hero
  const layout = resolveOptionId(editableHero.layout, layoutOptions, defaultLayout)
  const imageFocalPointX = editableHero.imageFocalPointX ?? defaultFocalPointX

  return {
    ...editableHero,
    title: showText === false ? '' : (editableHero.title ?? ''),
    subtext: showText === false ? '' : (editableHero.subtext ?? ''),
    buttonText: showButton === false ? '' : (editableHero.buttonText ?? defaultButtonText),
    layout,
    imageFocalPointX,
    imageFocalPointY: editableHero.imageFocalPointY ?? defaultFocalPointY,
    imageAltText: editableHero.imageAltText ?? '',
    preferredTextPosition: resolveHeroTextPosition({
      layout,
      position: preferredTextPosition,
      focalPointX: imageFocalPointX,
    }),
    preferredTextTone: resolveOptionId(preferredTextTone, heroTextToneOptions, 'auto'),
  }
}

export const serializeHeroValues = (hero = {}) => ({
  ...hero,
  showText: hasText(hero.title) || hasText(hero.subtext),
  showButton: hasText(hero.buttonText),
})
